<template>
  <div class="row no-gutters align-items-center">
    <div class="col light-background rounded-left">
      <select class="pl-2 right-chevron" v-model="filterProps.dateRangeType">
        <option value="creation">{{
            $t('reports.supplier-reports-search.creation-date-range')
          }}</option>
        <option value="departure">{{
            $t('reports.supplier-reports-search.departure-date-range')
          }}</option>
      </select>
    </div>
    <div class="col light-background rounded-right">
      <core-date-range-calendar
        :key="resetFormKey"
        :start.sync="filterProps.createdFrom"
        :end.sync="filterProps.createdUntil"
        :locale="'en-GB'"
        :placement="'top'"
      ></core-date-range-calendar>
    </div>
    <div class="input-group col">
      <input
        class="form-control search-input filter-border-bottom"
        name="reservation-id"
        v-model="filterProps.serviceCode"
        type="text"
        :placeholder="$t('reports.supplier-reports-search.service-code')"
      />
    </div>
    <div class="col">
      <select
        class="pl-2 right-chevron type-selection"
        v-model="filterProps.serviceTypeId"
      >
        <option value="">{{
            $t('reports.supplier-reports-search.type')
          }}</option>
        <option
          v-for="(type, index) in serviceTypes"
          :value="type.id"
          :key="index"
        >{{ type.name_NL }}</option
        >
      </select>
    </div>
    <div class="col">
      <select
        class="pl-2 right-chevron type-selection"
        v-model="filterProps.status"
      >
        <option value="">{{
            $t('reports.supplier-reports-search.all-statuses')
          }}</option>
        <option
          v-for="(st, index) in ['TODO', 'DONE']"
          :value="st"
          :key="index"
        >{{ st }}</option
        >
      </select>
    </div>
    <div class="col">
      <select
        class="pl-2 right-chevron type-selection"
        v-model="filterProps.country"
      >
        <option value="">{{
            $t('reports.supplier-reports-search.country')
          }}</option>
        <option
          v-for="(country, index) in countries"
          :value="country.code"
          :key="index"
        >{{ country['name_' + $i18n.locale.toUpperCase()] }}</option
        >
      </select>
    </div>
    <div class="col">
      <select
        class="pl-2 right-chevron category-selection"
        v-model="filterProps.user"
      >
        <option value="">{{
            $t('reports.supplier-reports-search.user')
          }}</option>
        <option
          v-for="(user, index) in users"
          :value="user.id"
          :key="index"
        >{{ user.lastName }} {{ user.firstName }}</option
        >
      </select>
    </div>
    <div class="col-1 text-right">
      <button @click="resetForm" class="btn btn-sm btn-primary">
        {{ $t('reports.supplier-reports-search.reset-form') }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ReservationPerson from '@/services/hatsApi/ReservationPerson'
import Geo from '@/services/hatsApi/Geo'

export default {
  data () {
    return {
      resetFormKey: false,
      filterProps: {
        dateRangeType: 'creation',
        reference: '',
        serviceCode: '',
        status: '',
        serviceTypeId: '',
        user: '',
        createdFrom: this.dateFrom,
        createdUntil: this.dateUntil
      },
      users: [],
      countries: []
    }
  },
  props: {
    dateFrom: {
      default: moment().format('YYYY-MM-DD'),
      type: String,
      required: false
    },
    dateUntil: {
      default: moment().format('YYYY-MM-DD'),
      type: String,
      required: false
    }
  },
  watch: {
    filterProps: {
      handler () {
        this.debouncedSearch()
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    ...mapGetters(['serviceTypes'])
  },
  async created () {
    Geo.getCountries().then((response) => {
      this.countries = response.data.data
    })
    this.debouncedSearch = this.$_.debounce(this.prepareAndEmitFilters, 500)
    this.getServiceTypes()
    let users = await ReservationPerson.getReservationUsers()
    if (users.data.success) {
      this.users = users.data.data
    }
  },
  methods: {
    async getServiceTypes () {
      await this.$store.dispatch('getServiceTypes')
    },
    resetForm () {
      this.resetFormKey = !this.resetFormKey
      this.filterProps = {
        dateRangeType: 'creation',
        serviceCode: '',
        serviceTypeId: '',
        reference: '',
        createdFrom: this.dateFrom,
        createdUntil: this.dateUntil
      }
    },
    prepareAndEmitFilters () {
      let filters = []
      const copiedFilters = { ...this.filterProps }
      if (copiedFilters.dateRangeType === 'departure') {
        copiedFilters.dateFrom = copiedFilters.createdFrom
        copiedFilters.dateUntil = copiedFilters.createdUntil
        delete copiedFilters.createdFrom
        delete copiedFilters.createdUntil
      }
      Object.keys(copiedFilters).forEach(filterProp => {
        if (filterProp !== 'dateRangeType' && copiedFilters[filterProp]) {
          let f = {
            property: `${filterProp}`,
            value: `${copiedFilters[filterProp]}`
          }
          filters.push(f)
        }
      })
      this.$emit('filtersUpdated', filters)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .vc-shadow {
  border: none;
  background-color: #f7fafc;
  box-shadow: none;
  color: #008cdd;
  font-family: 'Open Sans Semibold';
  font-size: 14px;
}

.light-background {
  .right-chevron {
    line-height: 35px;
  }
  background-color: #f7fafc;
}

.type-selection {
  font-family: 'Open Sans Italic';
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/SupplierReports.vue